import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import getPropertyValue from '../dataAccessHelpers/getPropertyValue';
import getPropertyDefinition from '../dataAccessHelpers/getPropertyDefinition';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentHighlightHeader = ({
  objectId,
  properties
}) => {
  const initialAmount = getPropertyValue(properties, 'hs_initial_amount');
  const initialAmountInSettlementCurrency = getPropertyValue(properties, 'hs_initial_amount_in_settlement_currency');
  const currencyCode = getPropertyValue(properties, 'hs_currency_code');
  const settlementCurrencyCode = getPropertyValue(properties, 'hs_settlement_currency_code');
  const paymentStatus = getPropertyValue(properties, 'hs_latest_status');
  const shouldDisplaySettlementCurrencyTooltip = !!settlementCurrencyCode && settlementCurrencyCode !== currencyCode && initialAmountInSettlementCurrency !== '' && !isNaN(Number(initialAmountInSettlementCurrency));
  const MaybeSettlementCurrencyHelpIcon = ({
    children
  }) => {
    if (shouldDisplaySettlementCurrencyTooltip) {
      return /*#__PURE__*/_jsx(HelpIcon, {
        "data-test-id": "settlement-currency-help-icon",
        title: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: Number(initialAmountInSettlementCurrency),
          currencyCode: settlementCurrencyCode
        }),
        children: children
      });
    }
    return children;
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(View, {
      paddingInlineEnd: "600",
      children: /*#__PURE__*/_jsx(MaybeSettlementCurrencyHelpIcon, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          display: "inline-block",
          children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
            "data-test-id": "payment-highlight-header-amount",
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            objectId: objectId,
            property: getPropertyDefinition(properties, 'hs_initial_amount'),
            value: initialAmount,
            getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
          })
        })
      })
    }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
      "data-test-id": "payment-highlight-header-status",
      objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
      objectId: objectId,
      property: getPropertyDefinition(properties, 'hs_latest_status'),
      value: paymentStatus,
      getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
    })]
  });
};
export default PaymentHighlightHeader;